import { logError } from "./logging";

const BUILD_VERSION_URL = "/build_version.json";

export async function fetchLatestBuildVersion(): Promise<string> {
  try {
    const response = await fetch(BUILD_VERSION_URL, {
      headers: {
        "Content-Type": "application/json",
      },
      // A cached copy would hide a new deploy from the refresh toast.
      cache: "no-store",
    });
    const body = (await response.json()) as { build_version: string };
    return body.build_version;
  } catch (err) {
    logError("Failed to get last version from server", err);
    throw err;
  }
}
export function refreshWebapp() {
  window.location.reload();
}
